export const colores_model = {
  Codigo: null,
  Descripcion: '',
  Hex: '#000000',
  Pantone: '',
};

export const colores_filters = {
  Descripcion: '',
};
